/* global axios */
import ApiClient from './ApiClient';

class LaisWhatsappOperationsAPI extends ApiClient {
  constructor() {
    super('lais_whatsapp_connections', { accountScoped: true });
  }

  snapshot(connectionId) {
    return axios.get(`${this.url}/${connectionId}/operations`);
  }

  execute(connectionId, operation, payload = {}) {
    return axios.post(`${this.url}/${connectionId}/operations/${operation}`, {
      payload,
    });
  }
}

export default new LaisWhatsappOperationsAPI();
